import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';

const productManagementMobileAvailableFilter = [
  {
    type: 'section',
    title: 'Categoria',
    onlyOneSelection: true,
    fieldName: 'tabs',
    options: [
      { label: 'Fundos de Investimentos', value: '0' },
      { label: 'Renda fixa', value: '1' },
    ],
  },
  {
    type: 'section',
    onlyOneSelection: true,
    title: 'Tipo',
    fieldName: 'blockType',
    options: [
      { label: 'Com bloqueio', value: 'blocked' },
      { label: 'Sem bloqueio', value: 'unblocked' },
      { label: 'Todos', value: 'all' },
    ],
  },
] as FilterModalTypes.FilterType[];

export interface ModalSelectedItems {
  destinationId: number;
  platformId: number;
  isClientOrAdvisor: 'client' | 'advisor' | undefined;
  clientOrAdvisorNameId?: { id: number; name: string };
  productList?: { id: number; name: string }[];
}

export const productBlockFilterAtom = atom<string>({
  key: 'productBlockFilter',
  default: 'all',
});

export const searchTermAtom = atom<string>({
  key: 'searchTerm',
  default: '',
});

export const modalSelectedItemsState = atom<ModalSelectedItems | null>({
  key: 'modalSelectedItemsState',
  default: null,
});

export const batchActionSelectedProductIds = atom<string[]>({
  key: 'batchActionSelectedProductIds',
  default: [],
});

export const batchActionState = atom<'block' | 'unblock' | null>({
  key: 'batchActionState',
  default: null,
});

export const productManagementMobileFilterState = atom<FilterModalTypes.FilterAtom>({
  key: 'productManagementMobileFilterState',
  default: {
    availableFilters: productManagementMobileAvailableFilter,
    selectedFilters: [],
    appliedFilters: [],
  },
});
